<template>
  <el-row type="flex" class="admin-header">
    <el-col :span="3" class="company-name">
      <router-link to="/admin/customers">
        <er-button type="text">
          <h3>Eruvaka Technologies</h3>
        </er-button>
      </router-link>
    </el-col>
    <el-col :span="24">
      <el-row>
        <el-menu
          class="admin-menu"
          mode="horizontal"
          :default-active="activeRoute"
          :router="true"
        >
          <el-menu-item index="customers" route="/admin/customers"
            >Customers</el-menu-item
          >
          <el-menu-item index="gateways" route="/admin/gateways"
            >Gateway</el-menu-item
          >
          <el-menu-item
            index="pondmothers"
            route="/admin/pondmothers?tab=details"
            >PondMother</el-menu-item
          >
          <el-menu-item index="pondguards" route="/admin/pondguards"
            >PondGuard</el-menu-item
          >
          <el-menu-item index="shrimptalks" route="/admin/shrimptalks"
            >ShrimpTalk</el-menu-item
          >
          <el-menu-item index="clients" route="/admin/clients"
            >Clients</el-menu-item
          >
          <el-menu-item index="dealers" route="/admin/dealers"
            >Dealer</el-menu-item
          >
          <el-menu-item index="account" route="/admin/account"
            >Account Manager</el-menu-item
          >
        </el-menu>
      </el-row>
    </el-col>
    <el-col :span="7">
      <center>
        <span>
          <span class="header-right-user-name truncate">
            <a href="/admin/profile">{{ getUserName }}</a>
          </span>
          <el-divider
            class="user-logout-divider"
            direction="vertical"
          ></el-divider>
          <er-button class="logout-button" @click="logout" type="text">
            <el-row type="flex" :gutter="5">
              <el-col>{{ $t("Comn_logout") }}</el-col>
              <el-col>
                <i class="el-icon-logout">
                  <img class="logout-icon" src="@/assets/logout.svg" />
                </i>
              </el-col>
            </el-row>
          </er-button>
        </span>
      </center>
    </el-col>
  </el-row>
</template>

<script>
export default {
  computed: {
    getUserName() {
      return (
        this.$store.getters["superadmin/getSuperAdminProfile"] &&
        this.$store.getters["superadmin/getSuperAdminProfile"].first_name +
          " " +
          this.$store.getters["superadmin/getSuperAdminProfile"].last_name
      );
    },
    activeRoute() {
      return this.$route.path.split("/")[2];
    }
  },
  methods: {
    async logout() {
      await this.$store.dispatch("auth/superAdminSignOut");
      this.$router.push("/");
    }
  }
};
</script>

<style lang="scss">
.admin-header {
  .company-name {
    line-height: 2.3;
  }
  .admin-menu {
    &.el-menu--horizontal > .el-menu-item {
      height: 44px !important;
      line-height: 44px !important;
    }
  }
  .header-right-user-name {
    max-width: 200px;
    a {
      text-transform: capitalize;
      text-decoration: none;
      font-size: 14px;
    }
  }
}
</style>
